import { defineAsyncComponent } from 'vue';

export const DESIGN_A = 'DESIGN_A';
export const DESIGN_B = 'DESIGN_B';

export const DISPOSITIVO = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
};

export const ENTITY_TYPES = {
  VIAJE: 'viaje',
  AGRUPACION: 'agrupacion',
};

export const BLOCK_TYPES = {
  SUMMARY: 'summary',
  EXPERIENCES: 'experiences',
  SERVICES: 'services',
  PAYMENTS: 'payments',
  TERMS: 'termsAndConditions',
  TEXT: 'text',
  ITINERARY: 'itinerary',
  IMAGES: 'images',
  VIDEO: 'video',
  IMAGES_AND_TEXT: 'imagesAndText',
  FILES: 'files',
  SPONSORS: 'sponsors',
  ACCOMMODATIONS: 'accommodations',
  ARTISTS: 'artists',
  CONTACT: 'contact',
  SOCIAL_MEDIA: 'socialMedia',
};

export function getBlockComponent(tipo, dispositivo = DISPOSITIVO.DESKTOP, entityType = ENTITY_TYPES.VIAJE) {
  const blockComponents = {
    [BLOCK_TYPES.SUMMARY]: {
      [DISPOSITIVO.DESKTOP]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/SummaryViajeBlockDesktop.vue'),
        [ENTITY_TYPES.AGRUPACION]: () =>
          import('@/views/productos/informacion/builder/SummaryAgrupacionBlockDesktop.vue'),
      },
      [DISPOSITIVO.MOBILE]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/SummaryViajeBlockMobile.vue'),
        [ENTITY_TYPES.AGRUPACION]: () =>
          import('@/views/productos/informacion/builder/SummaryAgrupacionBlockMobile.vue'),
      },
    },
    [BLOCK_TYPES.EXPERIENCES]: {
      [DISPOSITIVO.DESKTOP]: {
        [ENTITY_TYPES.AGRUPACION]: () =>
          import('@/views/productos/informacion/builder/ExperiencesAgrupacionBlockDesktop.vue'),
      },
      [DISPOSITIVO.MOBILE]: {
        [ENTITY_TYPES.AGRUPACION]: () =>
          import('@/views/productos/informacion/builder/ExperiencesAgrupacionBlockMobile.vue'),
      },
    },
    [BLOCK_TYPES.SERVICES]: {
      [DISPOSITIVO.DESKTOP]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/ServicesBlockDesktop.vue'),
      },
      [DISPOSITIVO.MOBILE]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/ServicesBlockMobile.vue'),
      },
    },
    [BLOCK_TYPES.TEXT]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/TextBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/TextBlockMobile.vue'),
    },
    [BLOCK_TYPES.ITINERARY]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/ItineraryBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/ItineraryBlockMobile.vue'),
    },
    [BLOCK_TYPES.VIDEO]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/VideoBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/VideoBlockMobile.vue'),
    },
    [BLOCK_TYPES.IMAGES]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/ImagesBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/ImagesBlockMobile.vue'),
    },
    [BLOCK_TYPES.TERMS]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/TermsBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/TermsBlockMobile.vue'),
    },
    [BLOCK_TYPES.PAYMENTS]: {
      [DISPOSITIVO.DESKTOP]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/PaymentsBlockDesktop.vue'),
      },
      [DISPOSITIVO.MOBILE]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/PaymentsBlockMobile.vue'),
      },
    },
    [BLOCK_TYPES.IMAGES_AND_TEXT]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/ImagesAndTextDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/ImagesAndTextMobile.vue'),
    },
    [BLOCK_TYPES.SPONSORS]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/SponsorsBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/SponsorsBlockMobile.vue'),
    },
    [BLOCK_TYPES.FILES]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/FilesBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/FilesBlockMobile.vue'),
    },
    [BLOCK_TYPES.ACCOMMODATIONS]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/AccommodationsBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/AccommodationsBlockMobile.vue'),
    },
    [BLOCK_TYPES.ARTISTS]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/ArtistsBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/ArtistsBlockMobile.vue'),
    },
    [BLOCK_TYPES.CONTACT]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/ContactBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/ContactBlockMobile.vue'),
    },
    [BLOCK_TYPES.SOCIAL_MEDIA]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/SocialMediaBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/SocialMediaBlockMobile.vue'),
    },
  };

  const componentConfig = blockComponents[tipo];
  if (!componentConfig) return null;

  const deviceConfig = componentConfig[dispositivo];
  if (!deviceConfig) return null;

  const component = typeof deviceConfig === 'object' ? deviceConfig[entityType] : deviceConfig;
  return component ? defineAsyncComponent(component) : null;
}

export function sortBlocksByOrder(blocks) {
  const visibleBlocks = blocks.filter(block => block.visible === true);
  return visibleBlocks.sort((a, b) => a.order - b.order);
}
